import { DayCard } from './DayCard'
import { type Recent } from './getRecent.server'

export default function Recent({ recent }: { recent: Recent }) {
  const { days } = recent

  return (
    <div>
      <h2 className="my-8 text-3xl font-bold">Current Session</h2>
      <div className="grid gap-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
        {days.map(day => (
          <DayCard key={day.id} day={day} />
        ))}
      </div>
    </div>
  )
}
